import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@mui/material';
import { useDataStoreList } from './DataStoreItemsListHooks';

export function DataStoreItemsList() {
  const { t } = useTranslation();
  const { dataStoreItems, currentDataset, selectDatasetAndRunner, setLoading, isLoading } = useDataStoreList();

  const handleDataStoreSelection = useCallback(
    (event, selectedDataStore) => {
      setLoading(true);
      selectDatasetAndRunner(selectedDataStore);
    },
    [selectDatasetAndRunner, setLoading]
  );

  const isDisabled = dataStoreItems.length === 0 || isLoading;

  const label = t('commoncomponents.datastore.select.label', 'Select a datastore');

  return (
    <Autocomplete
      sx={{ width: '100%', minWidth: '250px', maxWidth: '500px' }}
      data-cy="datastore-selector"
      ListboxProps={{ 'data-cy': 'datastore-selector-options' }}
      id="datastore-select"
      value={currentDataset || null}
      options={dataStoreItems}
      getOptionLabel={(option) => option?.name ?? ''}
      getOptionKey={(option) => option.id}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      noOptionsText={t('commoncomponents.datastore.select.noOptions', 'No datastore found')}
      onChange={handleDataStoreSelection}
      disabled={isDisabled}
      disableClearable
      renderInput={(params) => (
        <TextField {...params} data-cy="datastore-select-input" label={label} placeholder={label} />
      )}
    />
  );
}
